import {css} from '@emotion/react'
import {FileList} from '@/components/File'
import {useAiContext} from './AiContext.mjs'

const cssFiles = css({
    maxHeight: 200,
    backgroundColor: '#fff',
    padding: 12,
    borderRadius: 'inherit',
    overflowY: 'auto',

    '&:empty': {
        display: 'none',
    },
})

export const DraftFiles = props => {
    const ai = useAiContext()

    const onChange = ai.getIsDisabled() ?
        null
        :
        files => ai.setDraft(d => ({...d, files}))

    return (
        <FileList
            css={cssFiles}
            files={ai.draft.files}
            onChange={onChange}
            {...props}
        />
    )
}
